export type ITtrapTabKeyInModal = ($modal: IjQueryElm) => void;
export default function trapTabKeyInModal($modal: IjQueryElm) {
  function trapFocus(event: JQuery.KeyDownEvent) {
    const key = event.which || event.charCode || event.keyCode;
    // Tab Key
    if (key === 9) {
      const focusableElements =
        'a[href], area[href], input, select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
      const allModalChildren = $modal.find('*');
      const allModalChildrenVisible = allModalChildren.filter(focusableElements).filter(':visible');
      const numberOfallModalChildrenVisible = allModalChildrenVisible.length;
      const currentlyFocusedItem = $(':focus');
      const currentlyFocusedItemIndex = $(allModalChildrenVisible).index(currentlyFocusedItem);

      // Tab backwards
      if (event.shiftKey) {
        // If focused on first item and user preses back-tab, go to the last focusable item
        if (currentlyFocusedItemIndex === 0) {
          (allModalChildrenVisible.get(numberOfallModalChildrenVisible - 1) as HTMLElement).focus();
          event.preventDefault();
        }

        // Shift not pressed, going forward
      } else {
        // If focused on the last item and user preses tab, go to the first focusable item
        if (currentlyFocusedItemIndex === numberOfallModalChildrenVisible - 1) {
          (allModalChildrenVisible.get(0) as HTMLElement).focus();
          event.preventDefault();
        }
      }
    }
  }

  $modal.off('keydown', trapFocus).on('keydown', trapFocus);
}
